module.exports = __webpack_public_path__ + "img/icon-dart-cards.737db121.svg";